import React, { useEffect, useState, useRef } from "react";
import {  get } from "lodash";
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration';
import { useSelect, useAction } from 'hooks';
import { useHistory } from "react-router-dom";
dayjs.extend(duration)


const OTPTimer = () => {
  const history = useHistory()
  const runningSecondsRef = useRef(1)
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 5,
    seconds: 0
  });
  const isLoading = useSelect('loading.isLoading', { type: 'auth.resendOtp' })
  const isLoadingResendOtpForgotPassword = useSelect('loading.isLoading', { type: 'auth.resendOtpForgotPassword' })
  const resendOtpActionSignUp = useAction('auth.resendOtp')
  const resentOtpActionForgotPassword = useAction('auth.resendOtpForgotPassword')
  // const [isLoading, setIsLoading] = useState(false)
  const calculateTimeLeft = () => {

    const x = dayjs().add(5, 'minute').subtract(runningSecondsRef.current, 'second')

    const y = dayjs()
    let difference = dayjs.duration(x.diff(y))
    const diffInMiliseconds = difference.asMilliseconds()
    let timeLeft = null;

    if (diffInMiliseconds > 0) {
      timeLeft = {
        days: Math.floor(diffInMiliseconds / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diffInMiliseconds / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diffInMiliseconds / 1000 / 60) % 60),
        seconds: Math.floor((diffInMiliseconds / 1000) % 60)
      };

    }

    return timeLeft;
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
      runningSecondsRef.current = +runningSecondsRef.current+1
      localStorage.setItem('otp_running_seconds', +runningSecondsRef.current+1)
    }, 1000);

    return () => clearTimeout(timer);
  });

  useEffect(() => {
    const storageOtpRunningSeconds = localStorage.getItem('otp_running_seconds')
    if(storageOtpRunningSeconds)
      runningSecondsRef.current = storageOtpRunningSeconds

    calculateTimeLeft()

    return () => {
      runningSecondsRef.current = 1
      localStorage.removeItem('otp_running_seconds')
    }
  }, [])

  const resendOtp = async e => {
    e.preventDefault()
    if(history.location.state.url === '/sign-up'){
      resendOtpActionSignUp({
        mobile_number: history.location.state.mobile_number,
        password: history.location.state.password,
      }, () => {
        runningSecondsRef.current = 1
      })
    }

    if(history.location.state.url === '/forgot-password'){
      resentOtpActionForgotPassword({
        mobile_number: history.location.state.mobile_number
      }, () => {
        runningSecondsRef.current = 1
      })
    }

  }


  if(timeLeft){
    return (
      <div className="flex items-center justify-center mt-10 text-skin-muted">
        <p>OTP will be expired in ({get(timeLeft, 'minutes')}:{get(timeLeft, 'seconds')} {get(timeLeft, 'minutes') > 0 ? 'min' : 'sec'})</p>
      </div>
    )
  }


  return (
    <div className="flex flex-col items-center justify-center mt-10 space-y-10 text-skin-muted">
      <div className="text-center">If you did not receive the 6-digit code, please click {"Resend Code"} below</div>
      <p className="text-skin-primary underline cursor-pointer" onClick={resendOtp}>{isLoading || isLoadingResendOtpForgotPassword ? <div className="text-skin-white animate-spin h-5 w-5  m-auto" /> : 'Resend Code'}</p>
    </div>
  )

}

export default OTPTimer